export default __webpack_public_path__ + "static/media/arrow-right.e8cc44cf.svg";